import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faArrowUpRightFromSquare, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-view-accomplishment-treatments',
  templateUrl: './view-accomplishment-treatments.component.html',
  styleUrls: ['./view-accomplishment-treatments.component.scss'],
  standalone: false
})

export class ViewAccomplishmentTreatmentsComponent implements OnInit, OnChanges {
  //icons
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  faArrowUpRightFromSquare = faArrowUpRightFromSquare;

  html = "<p>Hello</p>"
  open = false;

  report = input.required<any>();
  reportList = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();

  totalUnits = 0;
  totalFunding = 0;

  treatmentList: any[] = [];
  treatmentTypes: any[] = [];
  
  methods = [
    { method_id: 0, method: 'Contract' },
    { method_id: 1, method: 'Agreement' },
    { method_id: 2, method: 'Force Account' }
  ]
  contract_status_list = [
    { contract_status_id: 0, contract_status: 'Pre-Award' },
    { contract_status_id: 1, contract_status: 'Awarded' },
    { contract_status_id: 2, contract_status: 'Implementing' },
    { contract_status_id: 3, contract_status: 'Work Completed' }
  ]

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    public readonly reportService: ReportService,
    public readonly accomplishmentService: AccomplishmentService,
  ) {
  }

  ngOnInit(): void {
    this.setupData();
    this.loaded.emit(2);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 3 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  setupData() {
    let totalFunding = 0;
    let totalUnits = 0;
    this.reportList().forEach((report: any) => {
      report.forests.forEach((forest: ReportForest) => {
        let totalItem = this.forestTotal(forest.treatments, forest.forest_name);
        totalFunding += totalItem.totalFunding;
        totalUnits += totalItem.totalUnits;
      });
    })
    this.totalFunding = totalFunding;
    this.totalUnits = totalUnits;

    this.treatmentTypes = this.treatmentTypes.reduce((acc, curr) => {
      if(!(acc.find((item: any) => item.treatment_type_id === curr.treatment_type_id)))
        acc.push(curr);
      return acc;
    }, <any>[]);
  }

  forestTotal(treatments: any[] | undefined, forest_name: string | undefined) {
    let totalFunding = 0;
    let totalUnits = 0;

    if (treatments == null) return {
      totalFunding,
      totalUnits,
    };
    for (let item of treatments) {
      this.treatmentTypes.push(item.treatment_type)
      //create form per treatment
      let treatmentData = this.report().accomplishment_treatments.find((data: any) => data.forest_treatment_id == item.forest_treatment_id)
      let form = {
        units: treatmentData?.units,
        date_completed: treatmentData?.date_completed,
        method_id: treatmentData?.method_id ?? '',
        method: treatmentData?.method?.text ?? '',
        contract_id: treatmentData?.contract_id,
        contract_status_id: treatmentData?.contract_status_id,
        agreement: treatmentData?.agreement,
        status_statement: this.customATOB(treatmentData?.status_statement),
      }
      this.treatmentList.push({
        form: form,
        treatment: item,
        accomplishment_treatment_id: treatmentData?.accomplishment_treatment_id,
        forest_name: forest_name
      })

      //compute totals
      let totalItem = this.unitTotal(item.treatment_specifications[0], { form: form, treatment: item }) || 0; // ?? Does not cover NaN
      totalFunding += totalItem.totalFunding;
      totalUnits += totalItem.totalUnits;
    }
    return {
      totalFunding,
      totalUnits,
    };
  }

  unitTotal(item: any, form: any) {
    return {
      totalFunding: (item.approved_unit_cost * item.approved_unit_qty) + (item.wo_approved_unit_cost * item.wo_approved_unit_qty),
      totalUnits: (item.approved_unit_qty ?? 0) + (item.wo_approved_unit_qty ?? 0),
    };
  }

  private getCompliantDate(rawDate: string): string | undefined {
    return rawDate ? new Date(rawDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: 'UTC'
    }) : undefined;
  }

  save_close() {
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  formatDate(date: Date) {
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replace(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    }));
  }

  onTreatmentClick(event: MouseEvent, accordion: MatAccordion): void {
    if (event.ctrlKey) {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  onTreatmentKeypress(event: any, accordion: MatAccordion): void {
    if (event.ctrlKey && event.key === "Enter") {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  calcTotalAuth(treatment: any) {
    const spec = treatment.treatment.treatment_specifications[0];
    return (spec.approved_unit_cost * spec.approved_unit_qty) + (spec.wo_approved_unit_cost * spec.wo_approved_unit_qty);
  }

  calcTotalCompleted(treatment: any) {
    const units = treatment.form.units;
    const spec = treatment.treatment.treatment_specifications[0];
    let total = 0;
    let unitsLeft = units - spec.approved_unit_qty;
    if (unitsLeft > 0) { //leftover gets used against wo approval
      total = (spec.approved_unit_cost * spec.approved_unit_qty) + (spec.wo_approved_unit_cost * units);
    } else { //only use ro ammount. below or equal to approved amount
      total = (spec.approved_unit_cost * units);
    }
    return total;
  }

  totalCompletedUnits() {
    let totalUnits = 0;
    for (let treatment of this.treatmentList) {
      totalUnits += treatment.form.units ?? 0;
    }
    return totalUnits;
  }

  totalCompletedFunding() {
    let total = 0;
    for (let treatment of this.treatmentList) {
      total += this.calcTotalCompleted(treatment);
    }
    return total;
  }
}
